import { render, staticRenderFns } from "./ResponsiveButton.vue?vue&type=template&id=6fb97fb0"
import script from "./ResponsiveButton.vue?vue&type=script&lang=js"
export * from "./ResponsiveButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports